<template>
  <main id="main-container">
    <Hero title="Notificaciones" page="Notificaciones" />
    <div class="content">
      <!-- DEVICES TABLE -->
      <div class="row">
        <Card>
          <template v-slot:header>
            <h4 class="card-title">Ultimas</h4>
            <span class="pull-right">
              Pagina: {{ data.currentPage }} de {{ data.totalPages }}</span
            >
          </template>

          <div class="table-responsive">
            <table class="table table-bordered table-striped table-vcenter">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Detalle</th>
                  <th class="text-center" style="width: 100px">Acciones</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(row, index) in data.data" v-bind:key="index">
                  <td>{{ unixToDate(row.time) }}</td>
                  <td>
                    El dispositivo *{{ row.deviceName }}* ha generado una alerta
                    en la variable <br />
                    [{{ row.variableFullName }} = [{{ row.payload }}] con
                    la condicion [{{ identifyCondition(row) }} {{ row.value }}]
                  </td>
                  <td>
                    <a
                      style="margin-right: 10px"
                      @click="notificationReaded(row._id, !row.readed)"
                    >
                      <span v-if="row.readed" class="fa fa-eye"></span>
                      <span v-else class="fa fa-eye-slash text-danger"></span>
                    </a>
                    <button
                      type="button"
                      class="btn btn-sm btn-alt-danger js-bs-tooltip-enabled"
                      title=""
                      @click="deleteNotif(row._id)"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <ul class="pagination justify-content-center">
              <!-- Botón "Previous" -->
              <li
                class="page-item"
                :class="{ disabled: data.currentPage === 1 }"
              >
                <a
                  class="page-link"
                  @click="changePage(data.currentPage - 1)"
                  tabindex="-1"
                  aria-label="Previous"
                >
                  <span aria-hidden="true">
                    <i class="fa fa-angle-double-left"></i>
                  </span>
                  <span class="visually-hidden">Previous</span>
                </a>
              </li>

              <!-- Números de página -->
              <template v-if="data.totalPages <= 10">
                <li
                  v-for="n in data.totalPages"
                  :key="n"
                  class="page-item"
                  :class="{ active: n === data.currentPage }"
                >
                  <a class="page-link" @click="changePage(n)">{{ n }}</a>
                </li>
              </template>

              <template v-else>
                <li
                  v-for="n in pages"
                  :key="n"
                  class="page-item"
                  :class="{ active: n === data.currentPage }"
                >
                  <a class="page-link" @click="changePage(n)">{{ n }}</a>
                </li>
              </template>

              <!-- Botón "Next" -->
              <li
                class="page-item"
                :class="{ disabled: data.currentPage === data.totalPages }"
              >
                <a
                  class="page-link"
                  @click="changePage(data.currentPage + 1)"
                  aria-label="Next"
                >
                  <span aria-hidden="true">
                    <i class="fa fa-angle-double-right"></i>
                  </span>
                  <span class="visually-hidden">Next</span>
                </a>
              </li>
            </ul>
            <span class="text-center"
              >Pagina: {{ data.currentPage }} de {{ data.totalPages }}</span
            >
          </div>
        </Card>
      </div>
    </div>
  </main>
</template>

<script>
import { onMounted, ref } from "vue";
import useApp from "@/composables/useApp";
import useNotifications from "@/composables/useNotifications";

export default {
  components: {},
  setup() {
    const { unixToDate } = useApp();
    const {
      getNotifications,
      data,
      changePage,
      pages,
      identifyCondition,
      deleteNotif,
      notificationReaded
    } = useNotifications();

    onMounted(async () => {
      await getNotifications();
    });

    return {
      identifyCondition,
      deleteNotif,
      unixToDate,
      notificationReaded,
      data,
      changePage,
      pages,
    };
  },
};
</script>
